import { Locale } from "@kizmann/pico-js";
import { CrudIndex } from "#pub/crud/index.js";

export default {

    extends: CrudIndex,

    name: 'LoginIndex',

    title: Locale.trans('All logins'),

    crud: {
        index: '/api/login',
        show: '/api/login/:id',
        create: '/api/login/create',
        update: '/api/login/:id',
        delete: '/api/login/delete',
    },

    urls: {
        index: 'login.index',
        item: 'login.item'
    },

    search: [
        'email',
    ],

    sort: [
        'created_at', 'desc'
    ],

    columns: [
        {
            type: 'string',
            prop: 'id',
            label: Locale.trans('ID'),
            visible: false,
            minWidth: 0,
            fixedWidth: 320,
        },
        {
            type: 'string',
            prop: 'email',
            label: Locale.trans('E-Mail'),
            sort: true,
            width: '30%',
        },
        {
            type: 'boolean',
            prop: 'is_super',
            label: Locale.trans('Super'),
            sort: true,
            fixedWidth: 120,
        },
        {
            type: 'datetime',
            prop: 'updated_at',
            label: Locale.trans('Updated'),
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
        {
            type: 'datetime',
            prop: 'created_at',
            label: Locale.trans('Created'),
            visible: true,
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
    ],

    renderForm()
    {
        return (<LoginForm />);
    }

}